import { ReactNode } from 'react';
import { action, makeObservable, observable } from 'mobx';

import { RightMenuProps } from '@components/RightMenu';

export class RightMenu {
    public children: ReactNode | ReactNode[] = '';
    @observable public isShowing: boolean = false;
    @observable public isCloseButtonHidden?: boolean = false;
    @observable public customWidth?: boolean;
    @observable public fullScreenHeight?: boolean;
    @observable public stickyButtonsLayout?: boolean;
    @observable public withoutMask?: boolean;
    @observable public closeOnEscOnly?: boolean;
    @observable public zIndex?: number;
    @observable public right?: number;
    @observable public onClickOutside?: () => void;

    constructor() {
        makeObservable(this);
    }

    @action
    public setRightMenu({
        isShowing = true,
        isCloseButtonHidden,
        children,
        customWidth,
        fullScreenHeight,
        stickyButtonsLayout,
        onClickOutside,
        withoutMask,
        closeOnEscOnly,
        right,
        zIndex,
    }: RightMenuProps): void {
        this.isShowing = isShowing;
        this.isCloseButtonHidden = isCloseButtonHidden;
        this.children = children;
        this.customWidth = customWidth;
        this.fullScreenHeight = fullScreenHeight;
        this.stickyButtonsLayout = stickyButtonsLayout;
        this.onClickOutside = onClickOutside;
        this.right = right;
        this.zIndex = zIndex;
        this.withoutMask = withoutMask;
        this.closeOnEscOnly = closeOnEscOnly;
    }

    @action
    public reset() {
        this.isShowing = false;
        this.isCloseButtonHidden = false;
        this.children = '';
        this.customWidth = undefined;
        this.fullScreenHeight = undefined;
        this.stickyButtonsLayout = undefined;
        this.onClickOutside = undefined;
        this.right = undefined;
        this.withoutMask = false;
        this.closeOnEscOnly = undefined;
    }
}
